import styled from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const Form = styled.h1`
  margin: 15px 0;
  text-align: center;
  color: ${COLOR.AZUL};
`;

export default Form;
